// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./chevron.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-input {
    height: 100%;
}
.date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup, .react-calendar,.react-date-picker__calendar {
    position: relative;
    /* width: 100%; */
    /* height: 100%; */
    z-index: 10;
    width: 270px !important;
    max-width: 270px !important;
}

.date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero) {
    color: rgba(144, 144, 144, 1) !important; 
}

.date-input :is(input, .react-date-picker__inputGroup__leadingZero) {
    color: #151514; 
}

.date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero)::placeholder {
    color: rgba(144, 144, 144, 1) !important; 
}

.date-input :is(input, .react-date-picker__inputGroup__leadingZero)::placeholder {
    color: #909090 !important; 
}

.react-date-picker__inputGroup__input--hasLeadingZero {
    padding-left: calc(1px + 0.49em);
}

.react-date-picker__wrapper {
    border-radius: 4px;
    border: 1px solid #B6B6B5 !important;
}

.react-date-picker__wrapper:hover {
    border: 1px solid #B6B6B5 !important;
}

.react-date-picker__inputGroup {
    display: flex;
    align-items: center;
}

.react-date-picker__inputGroup__input {
    height: auto !important;
} 

@media(max-width: 1280px) {
    .date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup, .react-calendar,.react-date-picker__calendar {
        position: relative;
        width: 220px !important;
        max-width: 220px !important;
    }
}

@media(max-width: 992px) {
    .react-date-picker__inputGroup {
        min-width: 164px;
    }
}


@media(max-width: 743px) {
    /* .date-input {
        height: 40px !important;
    } */
    .date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup {        
        width: 100% !important;
        max-width: 100% !important;
    }
    .date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero) {
        color: rgba(144, 144, 144, 1) !important;
    }
    .react-date-picker__wrapper {
        border: 1px solid transparent !important;
        background-color: #F2F2F2;
    }
    .date-input.black-theme .react-date-picker__wrapper {
        background-color: #3F4548;
    }
}

@media(max-width: 320px) {
    .date-input {
        /* height: 56px !important; */
        /* width: 221px !important; */
    }
    .react-date-picker__wrapper {
        /* width: 221px !important; */
        border: 1px solid transparent !important;
        background-color: #F2F2F2;
    }
    .react-date-picker__inputGroup__input {
        /* width: 70px !important;
        max-width: 70px !important;
        min-width: 40px !important; */
    }
}


.react-calendar__navigation {
    position: relative;
    margin-bottom: 0 !important;
    padding: 12px 16px 0 16px !important;
}

.react-calendar__navigation button:disabled {
    background-color: transparent !important;
}

.react-calendar__navigation button:disabled svg path {
    fill: #B6B6B5 !important;
}

.react-calendar__navigation__label {
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
    /* text-transform: uppercase; */
}

.react-calendar__navigation__label::first-letter {
    text-transform: uppercase;
}

.react-calendar__navigation__label::after {
    content: '';
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    position: absolute;
    top: 3.5px;
    transform: rotate(-90deg);
    right: -10px;
    width: 12px;
    height: 12px;
    display: block;
}

.react-calendar__navigation__next-button {
    position: absolute;
    top: 30%;
    width: 16px;
    height: 16px;
    right: 13.5px;
    min-width: 5px !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    padding: 0;
    color: transparent !important;
    transform: rotate(-90deg) translateY(-30%);;
}

.react-calendar__navigation__prev-button {
    position: absolute;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    color: transparent !important;
    padding: 0;
    width: 16px;
    height: 16px;
    top: 30%;
    right: 46px;
    min-width: 5px !important;
    transform: rotate(90deg) translateY(-30%);
}


.react-calendar__navigation__prev2-button {
    display: none !important;
}

.react-calendar__navigation__next2-button {
    display: none;
}


.react-calendar__month-view__days__day {
    display: flex;
    justify-content: center;
    color: #909090 !important;
    margin: 0  0 6px 0!important;
    padding: 1.5px 0 !important;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
}

.react-calendar__month-view__days__day--neighboringMonth {
    color: #BFBFBF !important;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    justify-content: center;
    margin: 0  0 6px 0!important;
    padding: 1.5px !important;
}

.react-calendar__month-view__weekdays {
    margin-bottom: 8px !important;
}

.react-calendar__month-view__weekdays__weekday {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    padding-right: 14px !important;
    text-transform: lowercase !important;
}

.react-calendar__month-view__weekdays__weekday * {
    text-decoration: none !important;
}

.react-calendar__navigation__label__labelText {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
    color: #909090 !important;
}

.react-date-picker__inputGroup__divider {
    color: transparent;
    display: none;
}

.date-input.not-empty .react-date-picker__inputGroup__divider {
    position: relative;
    left: -0.5px;
    width: 4px;
    display: block;
}

/* .react-date-picker__inputGroup {
    max-width: 189px;
} */


.react-date-picker__inputGroup__divider::before {
    content: '.';
    position: absolute;
    bottom: 1px;
    left: 0;
    display: block;
    color: #151514;
}

.date-input.black-theme .react-date-picker__inputGroup__divider::before {
    color: #F2F2F2 !important;
}

.react-date-picker__inputGroup__input {
    border: none;
    outline: none;
}

.react-date-picker__inputGroup {
    padding-left: 16px !important;
}

.react-date-picker__inputGroup__input:invalid {
    background-color: transparent !important;
}

.react-date-picker__calendar {
    z-index: 3 !important;
}

.react-date-picker__calendar {
    /* max-width: 221px !important;
    max-height: 256px !important; */
}

.react-calendar__viewContainer {
    padding: 4px 16px 24px 16px !important;
}

/* .react-calendar {
    max-width: 221px !important;
    max-height: 256px !important;
} */


.react-date-picker__inputGroup__leadingZero {
    color: #151514 !important;
}

.react-date-picker__inputGroup__month::placeholder {
    opacity: 0;
}

.react-date-picker__inputGroup__year::placeholder {
    opacity: 0;
}

/* .react-calendar__tile {
    display: flex;
    justify-content: center;
    color: #909090 !important;
    margin: 0  0 12px 0!important;
    padding: 3px !important;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
} */


.react-calendar__year-view .react-calendar__tile {
    display: flex;
    justify-content: center;
    color: #151514 !important;
    margin: 0  0 12px 0!important;
    padding: 0 !important;

    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
}

.react-calendar button .react-calendar__tile--now {
    color: white;
}

.react-calendar button:hover {
    border-radius: 3px;
}

.react-calendar__tile--active {
    background-color: #151514 !important;
    border-radius: 3px;
}

.react-calendar__tile--active * {
    color: white !important;
}

.react-calendar__tile--hasActive {
    background-color: #151514 !important;
    border-radius: 3px;
    color: white;
}

.react-calendar__tile--hasActive * {
    padding: 2px !important;
    color: white;
}

.react-calendar__tile--now {
    background-color: #909090 !important;
    color: white !important;
    border-radius: 3px;
}

/* .date-input::after {
    content: '';
    position: absolute;
    width: 32px;
    height: 32px;
    /* background:url("./date32.svg") #f7f9fc no-repeat 97% 50%;
    display: block;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
}

/* input[type=date]::-webkit-calendar-picker-indicator {
    opacity: 0;
    right: 10px;
    top: 50%;
    width: 32px;
    height: 32px;
    transform: translateY(-50%);
    position: absolute;
    z-index: 2;
  }

  input[type=date]::-webkit-clear-button {
    color: #BFBFBF;
  }
  input[type=date]::-webkit-datetime-edit { padding: 1em; }
  input[type=date]::-webkit-datetime-edit-fields-wrapper { background: silver; }
  input[type=date]::-webkit-datetime-edit-text { color: red; padding: 0 0.3em; }
  input[type=date]::-webkit-datetime-edit-month-field { color: blue; }
  input[type=date]::-webkit-datetime-edit-day-field { color: green; }
  input[type=date]::-webkit-datetime-edit-year-field { color: purple; }
  input[type=date]::-webkit-inner-spin-button { display: none; }
  input[type=date]::-webkit-datetime-edit {
    -webkit-flex: 1;
    -webkit-user-modify: read-only !important;
    display: inline-block;
    min-width: 0;
    overflow: hidden;
    color: tomato;
} */

  /* input[type=date]{
	background:url("./date32.svg") #f7f9fc no-repeat 97% 50%;
    } */

/* @media(max-width: 940px) {
    .date-input::after {
        content: '';
        position: absolute;
        width: 32px;
        height: 32px;
        background:url("./date24.svg") #f7f9fc no-repeat 97% 50%;
        display: inline-block;
        top: 50%;
        transform: translateY(-50%);
        right: 16px;
    }
} */`, "",{"version":3,"sources":["webpack://./src/shared/components/tagAdminProjectsSearchBar/styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,kBAAkB;QAClB,uBAAuB;QACvB,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;;AAGA;IACI;;OAEG;IACH;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;IACA;QACI,wCAAwC;IAC5C;IACA;QACI,wCAAwC;QACxC,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,6BAA6B;IACjC;IACA;QACI,6BAA6B;QAC7B,wCAAwC;QACxC,yBAAyB;IAC7B;IACA;QACI;;qCAE6B;IACjC;AACJ;;;AAGA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yDAAsC;IACtC,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,oEAAiD;IACjD,uCAAuC;IACvC,mCAAmC;IACnC,UAAU;IACV,6BAA6B;IAC7B,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,oEAAiD;IACjD,uCAAuC;IACvC,mCAAmC;IACnC,6BAA6B;IAC7B,UAAU;IACV,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,yCAAyC;AAC7C;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,cAAc;AAClB;;AAEA;;GAEG;;;AAGH;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;mCAC+B;AACnC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;;GAGG;;;AAGH;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;;;;;;;;;;GAWG;;;AAGH;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,qBAAqB;;IAErB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwCG;;EAED;;OAEK;;AAEP;;;;;;;;;;;;GAYG","sourcesContent":[".date-input {\n    height: 100%;\n}\n.date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup, .react-calendar,.react-date-picker__calendar {\n    position: relative;\n    /* width: 100%; */\n    /* height: 100%; */\n    z-index: 10;\n    width: 270px !important;\n    max-width: 270px !important;\n}\n\n.date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero) {\n    color: rgba(144, 144, 144, 1) !important; \n}\n\n.date-input :is(input, .react-date-picker__inputGroup__leadingZero) {\n    color: #151514; \n}\n\n.date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero)::placeholder {\n    color: rgba(144, 144, 144, 1) !important; \n}\n\n.date-input :is(input, .react-date-picker__inputGroup__leadingZero)::placeholder {\n    color: #909090 !important; \n}\n\n.react-date-picker__inputGroup__input--hasLeadingZero {\n    padding-left: calc(1px + 0.49em);\n}\n\n.react-date-picker__wrapper {\n    border-radius: 4px;\n    border: 1px solid #B6B6B5 !important;\n}\n\n.react-date-picker__wrapper:hover {\n    border: 1px solid #B6B6B5 !important;\n}\n\n.react-date-picker__inputGroup {\n    display: flex;\n    align-items: center;\n}\n\n.react-date-picker__inputGroup__input {\n    height: auto !important;\n} \n\n@media(max-width: 1280px) {\n    .date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup, .react-calendar,.react-date-picker__calendar {\n        position: relative;\n        width: 220px !important;\n        max-width: 220px !important;\n    }\n}\n\n@media(max-width: 992px) {\n    .react-date-picker__inputGroup {\n        min-width: 164px;\n    }\n}\n\n\n@media(max-width: 743px) {\n    /* .date-input {\n        height: 40px !important;\n    } */\n    .date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup {        \n        width: 100% !important;\n        max-width: 100% !important;\n    }\n    .date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero) {\n        color: rgba(144, 144, 144, 1) !important;\n    }\n    .react-date-picker__wrapper {\n        border: 1px solid transparent !important;\n        background-color: #F2F2F2;\n    }\n    .date-input.black-theme .react-date-picker__wrapper {\n        background-color: #3F4548;\n    }\n}\n\n@media(max-width: 320px) {\n    .date-input {\n        /* height: 56px !important; */\n        /* width: 221px !important; */\n    }\n    .react-date-picker__wrapper {\n        /* width: 221px !important; */\n        border: 1px solid transparent !important;\n        background-color: #F2F2F2;\n    }\n    .react-date-picker__inputGroup__input {\n        /* width: 70px !important;\n        max-width: 70px !important;\n        min-width: 40px !important; */\n    }\n}\n\n\n.react-calendar__navigation {\n    position: relative;\n    margin-bottom: 0 !important;\n    padding: 12px 16px 0 16px !important;\n}\n\n.react-calendar__navigation button:disabled {\n    background-color: transparent !important;\n}\n\n.react-calendar__navigation button:disabled svg path {\n    fill: #B6B6B5 !important;\n}\n\n.react-calendar__navigation__label {\n    position: absolute;\n    top: 50%;\n    left: 16px;\n    transform: translateY(-50%);\n    /* text-transform: uppercase; */\n}\n\n.react-calendar__navigation__label::first-letter {\n    text-transform: uppercase;\n}\n\n.react-calendar__navigation__label::after {\n    content: '';\n    background-image: url('./chevron.svg');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    position: absolute;\n    top: 3.5px;\n    transform: rotate(-90deg);\n    right: -10px;\n    width: 12px;\n    height: 12px;\n    display: block;\n}\n\n.react-calendar__navigation__next-button {\n    position: absolute;\n    top: 30%;\n    width: 16px;\n    height: 16px;\n    right: 13.5px;\n    min-width: 5px !important;\n    background-image: url('./chevron.svg') !important;\n    background-repeat: no-repeat !important;\n    background-size: contain !important;\n    padding: 0;\n    color: transparent !important;\n    transform: rotate(-90deg) translateY(-30%);;\n}\n\n.react-calendar__navigation__prev-button {\n    position: absolute;\n    background-image: url('./chevron.svg') !important;\n    background-repeat: no-repeat !important;\n    background-size: contain !important;\n    color: transparent !important;\n    padding: 0;\n    width: 16px;\n    height: 16px;\n    top: 30%;\n    right: 46px;\n    min-width: 5px !important;\n    transform: rotate(90deg) translateY(-30%);\n}\n\n\n.react-calendar__navigation__prev2-button {\n    display: none !important;\n}\n\n.react-calendar__navigation__next2-button {\n    display: none;\n}\n\n\n.react-calendar__month-view__days__day {\n    display: flex;\n    justify-content: center;\n    color: #909090 !important;\n    margin: 0  0 6px 0!important;\n    padding: 1.5px 0 !important;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n}\n\n.react-calendar__month-view__days__day--neighboringMonth {\n    color: #BFBFBF !important;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n    display: flex;\n    justify-content: center;\n    margin: 0  0 6px 0!important;\n    padding: 1.5px !important;\n}\n\n.react-calendar__month-view__weekdays {\n    margin-bottom: 8px !important;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    padding-right: 14px !important;\n    text-transform: lowercase !important;\n}\n\n.react-calendar__month-view__weekdays__weekday * {\n    text-decoration: none !important;\n}\n\n.react-calendar__navigation__label__labelText {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 13px;\n    line-height: 16px;\n    color: #909090 !important;\n}\n\n.react-date-picker__inputGroup__divider {\n    color: transparent;\n    display: none;\n}\n\n.date-input.not-empty .react-date-picker__inputGroup__divider {\n    position: relative;\n    left: -0.5px;\n    width: 4px;\n    display: block;\n}\n\n/* .react-date-picker__inputGroup {\n    max-width: 189px;\n} */\n\n\n.react-date-picker__inputGroup__divider::before {\n    content: '.';\n    position: absolute;\n    bottom: 1px;\n    left: 0;\n    display: block;\n    color: #151514;\n}\n\n.date-input.black-theme .react-date-picker__inputGroup__divider::before {\n    color: #F2F2F2 !important;\n}\n\n.react-date-picker__inputGroup__input {\n    border: none;\n    outline: none;\n}\n\n.react-date-picker__inputGroup {\n    padding-left: 16px !important;\n}\n\n.react-date-picker__inputGroup__input:invalid {\n    background-color: transparent !important;\n}\n\n.react-date-picker__calendar {\n    z-index: 3 !important;\n}\n\n.react-date-picker__calendar {\n    /* max-width: 221px !important;\n    max-height: 256px !important; */\n}\n\n.react-calendar__viewContainer {\n    padding: 4px 16px 24px 16px !important;\n}\n\n/* .react-calendar {\n    max-width: 221px !important;\n    max-height: 256px !important;\n} */\n\n\n.react-date-picker__inputGroup__leadingZero {\n    color: #151514 !important;\n}\n\n.react-date-picker__inputGroup__month::placeholder {\n    opacity: 0;\n}\n\n.react-date-picker__inputGroup__year::placeholder {\n    opacity: 0;\n}\n\n/* .react-calendar__tile {\n    display: flex;\n    justify-content: center;\n    color: #909090 !important;\n    margin: 0  0 12px 0!important;\n    padding: 3px !important;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n} */\n\n\n.react-calendar__year-view .react-calendar__tile {\n    display: flex;\n    justify-content: center;\n    color: #151514 !important;\n    margin: 0  0 12px 0!important;\n    padding: 0 !important;\n\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 13px;\n}\n\n.react-calendar button .react-calendar__tile--now {\n    color: white;\n}\n\n.react-calendar button:hover {\n    border-radius: 3px;\n}\n\n.react-calendar__tile--active {\n    background-color: #151514 !important;\n    border-radius: 3px;\n}\n\n.react-calendar__tile--active * {\n    color: white !important;\n}\n\n.react-calendar__tile--hasActive {\n    background-color: #151514 !important;\n    border-radius: 3px;\n    color: white;\n}\n\n.react-calendar__tile--hasActive * {\n    padding: 2px !important;\n    color: white;\n}\n\n.react-calendar__tile--now {\n    background-color: #909090 !important;\n    color: white !important;\n    border-radius: 3px;\n}\n\n/* .date-input::after {\n    content: '';\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    /* background:url(\"./date32.svg\") #f7f9fc no-repeat 97% 50%;\n    display: block;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 16px;\n}\n\n/* input[type=date]::-webkit-calendar-picker-indicator {\n    opacity: 0;\n    right: 10px;\n    top: 50%;\n    width: 32px;\n    height: 32px;\n    transform: translateY(-50%);\n    position: absolute;\n    z-index: 2;\n  }\n\n  input[type=date]::-webkit-clear-button {\n    color: #BFBFBF;\n  }\n  input[type=date]::-webkit-datetime-edit { padding: 1em; }\n  input[type=date]::-webkit-datetime-edit-fields-wrapper { background: silver; }\n  input[type=date]::-webkit-datetime-edit-text { color: red; padding: 0 0.3em; }\n  input[type=date]::-webkit-datetime-edit-month-field { color: blue; }\n  input[type=date]::-webkit-datetime-edit-day-field { color: green; }\n  input[type=date]::-webkit-datetime-edit-year-field { color: purple; }\n  input[type=date]::-webkit-inner-spin-button { display: none; }\n  input[type=date]::-webkit-datetime-edit {\n    -webkit-flex: 1;\n    -webkit-user-modify: read-only !important;\n    display: inline-block;\n    min-width: 0;\n    overflow: hidden;\n    color: tomato;\n} */\n\n  /* input[type=date]{\n\tbackground:url(\"./date32.svg\") #f7f9fc no-repeat 97% 50%;\n    } */\n\n/* @media(max-width: 940px) {\n    .date-input::after {\n        content: '';\n        position: absolute;\n        width: 32px;\n        height: 32px;\n        background:url(\"./date24.svg\") #f7f9fc no-repeat 97% 50%;\n        display: inline-block;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 16px;\n    }\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.3_webpack@5.94.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./chevron.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-input {
    height: 100%;
}
.date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup, .react-calendar,.react-date-picker__calendar {
    position: relative;
    /* width: 100%; */
    /* height: 100%; */
    z-index: 10;
    width: 270px !important;
    max-width: 270px !important;
}

.date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero) {
    color: rgba(144, 144, 144, 1) !important; 
}

.date-input :is(input, .react-date-picker__inputGroup__leadingZero) {
    color: #151514; 
}

.date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero)::placeholder {
    color: rgba(144, 144, 144, 1) !important; 
}

.date-input :is(input, .react-date-picker__inputGroup__leadingZero)::placeholder {
    color: #909090 !important; 
}

.react-date-picker__inputGroup__input--hasLeadingZero {
    padding-left: calc(1px + 0.49em);
}

.react-date-picker__wrapper {
    border-radius: 4px;
    border: 1px solid #B6B6B5 !important;
}

.react-date-picker__wrapper:hover {
    border: 1px solid #B6B6B5 !important;
}

.react-date-picker__inputGroup {
    display: flex;
    align-items: center;
}

.react-date-picker__inputGroup__input {
    height: auto !important;
} 

@media(max-width: 1280px) {
    .date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup, .react-calendar,.react-date-picker__calendar {
        position: relative;
        width: 220px !important;
        max-width: 220px !important;
    }
}

@media(max-width: 992px) {
    .react-date-picker__inputGroup {
        min-width: 164px;
    }
}


@media(max-width: 743px) {
    /* .date-input {
        height: 40px !important;
    } */
    .date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup {        
        width: 100% !important;
        max-width: 100% !important;
    }
    .date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero) {
        color: rgba(144, 144, 144, 1) !important;
    }
    .react-date-picker__wrapper {
        border: 1px solid transparent !important;
        background-color: #F2F2F2;
    }
    .date-input.black-theme .react-date-picker__wrapper {
        background-color: #3F4548;
    }
}

@media(max-width: 320px) {
    .date-input {
        /* height: 56px !important; */
        /* width: 221px !important; */
    }
    .react-date-picker__wrapper {
        /* width: 221px !important; */
        border: 1px solid transparent !important;
        background-color: #F2F2F2;
    }
    .react-date-picker__inputGroup__input {
        /* width: 70px !important;
        max-width: 70px !important;
        min-width: 40px !important; */
    }
}


.react-calendar__navigation {
    position: relative;
    margin-bottom: 0 !important;
    padding: 12px 16px 0 16px !important;
}

.react-calendar__navigation button:disabled {
    background-color: transparent !important;
}

.react-calendar__navigation button:disabled svg path {
    fill: #B6B6B5 !important;
}

.react-calendar__navigation__label {
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
    /* text-transform: uppercase; */
}

.react-calendar__navigation__label::first-letter {
    text-transform: uppercase;
}

.react-calendar__navigation__label::after {
    content: '';
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    position: absolute;
    top: 3.5px;
    transform: rotate(-90deg);
    right: -10px;
    width: 12px;
    height: 12px;
    display: block;
}

.react-calendar__navigation__next-button {
    position: absolute;
    top: 30%;
    width: 16px;
    height: 16px;
    right: 13.5px;
    min-width: 5px !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    padding: 0;
    color: transparent !important;
    transform: rotate(-90deg) translateY(-30%);;
}

.react-calendar__navigation__prev-button {
    position: absolute;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    color: transparent !important;
    padding: 0;
    width: 16px;
    height: 16px;
    top: 30%;
    right: 46px;
    min-width: 5px !important;
    transform: rotate(90deg) translateY(-30%);
}


.react-calendar__navigation__prev2-button {
    display: none !important;
}

.react-calendar__navigation__next2-button {
    display: none;
}


.react-calendar__month-view__days__day {
    display: flex;
    justify-content: center;
    color: #909090 !important;
    margin: 0  0 6px 0!important;
    padding: 1.5px 0 !important;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
}

.react-calendar__month-view__days__day--neighboringMonth {
    color: #BFBFBF !important;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    justify-content: center;
    margin: 0  0 6px 0!important;
    padding: 1.5px !important;
}

.react-calendar__month-view__weekdays {
    margin-bottom: 8px !important;
}

.react-calendar__month-view__weekdays__weekday {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    padding-right: 14px !important;
    text-transform: lowercase !important;
}

.react-calendar__month-view__weekdays__weekday * {
    text-decoration: none !important;
}

.react-calendar__navigation__label__labelText {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
    color: #909090 !important;
}

.react-date-picker__inputGroup__divider {
    color: transparent;
    display: none;
}

.date-input.not-empty .react-date-picker__inputGroup__divider {
    position: relative;
    left: -0.5px;
    width: 4px;
    display: block;
}

/* .react-date-picker__inputGroup {
    max-width: 189px;
} */


.react-date-picker__inputGroup__divider::before {
    content: '.';
    position: absolute;
    bottom: 1px;
    left: 0;
    display: block;
    color: #151514;
}

.date-input.black-theme .react-date-picker__inputGroup__divider::before {
    color: #F2F2F2 !important;
}

.react-date-picker__inputGroup__input {
    border: none;
    outline: none;
}

.react-date-picker__inputGroup {
    padding-left: 16px !important;
}

.react-date-picker__inputGroup__input:invalid {
    background-color: transparent !important;
}

.react-date-picker__calendar {
    z-index: 3 !important;
}

.react-date-picker__calendar {
    /* max-width: 221px !important;
    max-height: 256px !important; */
}

.react-calendar__viewContainer {
    padding: 4px 16px 24px 16px !important;
}

/* .react-calendar {
    max-width: 221px !important;
    max-height: 256px !important;
} */


.react-date-picker__inputGroup__leadingZero {
    color: #151514 !important;
}

.react-date-picker__inputGroup__month::placeholder {
    opacity: 0;
}

.react-date-picker__inputGroup__year::placeholder {
    opacity: 0;
}

/* .react-calendar__tile {
    display: flex;
    justify-content: center;
    color: #909090 !important;
    margin: 0  0 12px 0!important;
    padding: 3px !important;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
} */


.react-calendar__year-view .react-calendar__tile {
    display: flex;
    justify-content: center;
    color: #151514 !important;
    margin: 0  0 12px 0!important;
    padding: 0 !important;

    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
}

.react-calendar button .react-calendar__tile--now {
    color: white;
}

.react-calendar button:hover {
    border-radius: 3px;
}

.react-calendar__tile--active {
    background-color: #151514 !important;
    border-radius: 3px;
}

.react-calendar__tile--active * {
    color: white !important;
}

.react-calendar__tile--hasActive {
    background-color: #151514 !important;
    border-radius: 3px;
    color: white;
}

.react-calendar__tile--hasActive * {
    padding: 2px !important;
    color: white;
}

.react-calendar__tile--now {
    background-color: #909090 !important;
    color: white !important;
    border-radius: 3px;
}

/* .date-input::after {
    content: '';
    position: absolute;
    width: 32px;
    height: 32px;
    /* background:url("./date32.svg") #f7f9fc no-repeat 97% 50%;
    display: block;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
}

/* input[type=date]::-webkit-calendar-picker-indicator {
    opacity: 0;
    right: 10px;
    top: 50%;
    width: 32px;
    height: 32px;
    transform: translateY(-50%);
    position: absolute;
    z-index: 2;
  }

  input[type=date]::-webkit-clear-button {
    color: #BFBFBF;
  }
  input[type=date]::-webkit-datetime-edit { padding: 1em; }
  input[type=date]::-webkit-datetime-edit-fields-wrapper { background: silver; }
  input[type=date]::-webkit-datetime-edit-text { color: red; padding: 0 0.3em; }
  input[type=date]::-webkit-datetime-edit-month-field { color: blue; }
  input[type=date]::-webkit-datetime-edit-day-field { color: green; }
  input[type=date]::-webkit-datetime-edit-year-field { color: purple; }
  input[type=date]::-webkit-inner-spin-button { display: none; }
  input[type=date]::-webkit-datetime-edit {
    -webkit-flex: 1;
    -webkit-user-modify: read-only !important;
    display: inline-block;
    min-width: 0;
    overflow: hidden;
    color: tomato;
} */

  /* input[type=date]{
	background:url("./date32.svg") #f7f9fc no-repeat 97% 50%;
    } */

/* @media(max-width: 940px) {
    .date-input::after {
        content: '';
        position: absolute;
        width: 32px;
        height: 32px;
        background:url("./date24.svg") #f7f9fc no-repeat 97% 50%;
        display: inline-block;
        top: 50%;
        transform: translateY(-50%);
        right: 16px;
    }
} */`, "",{"version":3,"sources":["webpack://./src/shared/components/tagAdminProjectsSearchBar/styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,kBAAkB;QAClB,uBAAuB;QACvB,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;;AAGA;IACI;;OAEG;IACH;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;IACA;QACI,wCAAwC;IAC5C;IACA;QACI,wCAAwC;QACxC,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,6BAA6B;IACjC;IACA;QACI,6BAA6B;QAC7B,wCAAwC;QACxC,yBAAyB;IAC7B;IACA;QACI;;qCAE6B;IACjC;AACJ;;;AAGA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yDAAsC;IACtC,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,oEAAiD;IACjD,uCAAuC;IACvC,mCAAmC;IACnC,UAAU;IACV,6BAA6B;IAC7B,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,oEAAiD;IACjD,uCAAuC;IACvC,mCAAmC;IACnC,6BAA6B;IAC7B,UAAU;IACV,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,yCAAyC;AAC7C;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,cAAc;AAClB;;AAEA;;GAEG;;;AAGH;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;mCAC+B;AACnC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;;GAGG;;;AAGH;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;;;;;;;;;;GAWG;;;AAGH;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,qBAAqB;;IAErB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwCG;;EAED;;OAEK;;AAEP;;;;;;;;;;;;GAYG","sourcesContent":[".date-input {\n    height: 100%;\n}\n.date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup, .react-calendar,.react-date-picker__calendar {\n    position: relative;\n    /* width: 100%; */\n    /* height: 100%; */\n    z-index: 10;\n    width: 270px !important;\n    max-width: 270px !important;\n}\n\n.date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero) {\n    color: rgba(144, 144, 144, 1) !important; \n}\n\n.date-input :is(input, .react-date-picker__inputGroup__leadingZero) {\n    color: #151514; \n}\n\n.date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero)::placeholder {\n    color: rgba(144, 144, 144, 1) !important; \n}\n\n.date-input :is(input, .react-date-picker__inputGroup__leadingZero)::placeholder {\n    color: #909090 !important; \n}\n\n.react-date-picker__inputGroup__input--hasLeadingZero {\n    padding-left: calc(1px + 0.49em);\n}\n\n.react-date-picker__wrapper {\n    border-radius: 4px;\n    border: 1px solid #B6B6B5 !important;\n}\n\n.react-date-picker__wrapper:hover {\n    border: 1px solid #B6B6B5 !important;\n}\n\n.react-date-picker__inputGroup {\n    display: flex;\n    align-items: center;\n}\n\n.react-date-picker__inputGroup__input {\n    height: auto !important;\n} \n\n@media(max-width: 1280px) {\n    .date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup, .react-calendar,.react-date-picker__calendar {\n        position: relative;\n        width: 220px !important;\n        max-width: 220px !important;\n    }\n}\n\n@media(max-width: 992px) {\n    .react-date-picker__inputGroup {\n        min-width: 164px;\n    }\n}\n\n\n@media(max-width: 743px) {\n    /* .date-input {\n        height: 40px !important;\n    } */\n    .date-input, .react-date-picker__wrapper, .react-date-picker__inputGroup {        \n        width: 100% !important;\n        max-width: 100% !important;\n    }\n    .date-input.black-theme :is(input, .react-date-picker__inputGroup__leadingZero) {\n        color: rgba(144, 144, 144, 1) !important;\n    }\n    .react-date-picker__wrapper {\n        border: 1px solid transparent !important;\n        background-color: #F2F2F2;\n    }\n    .date-input.black-theme .react-date-picker__wrapper {\n        background-color: #3F4548;\n    }\n}\n\n@media(max-width: 320px) {\n    .date-input {\n        /* height: 56px !important; */\n        /* width: 221px !important; */\n    }\n    .react-date-picker__wrapper {\n        /* width: 221px !important; */\n        border: 1px solid transparent !important;\n        background-color: #F2F2F2;\n    }\n    .react-date-picker__inputGroup__input {\n        /* width: 70px !important;\n        max-width: 70px !important;\n        min-width: 40px !important; */\n    }\n}\n\n\n.react-calendar__navigation {\n    position: relative;\n    margin-bottom: 0 !important;\n    padding: 12px 16px 0 16px !important;\n}\n\n.react-calendar__navigation button:disabled {\n    background-color: transparent !important;\n}\n\n.react-calendar__navigation button:disabled svg path {\n    fill: #B6B6B5 !important;\n}\n\n.react-calendar__navigation__label {\n    position: absolute;\n    top: 50%;\n    left: 16px;\n    transform: translateY(-50%);\n    /* text-transform: uppercase; */\n}\n\n.react-calendar__navigation__label::first-letter {\n    text-transform: uppercase;\n}\n\n.react-calendar__navigation__label::after {\n    content: '';\n    background-image: url('./chevron.svg');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    position: absolute;\n    top: 3.5px;\n    transform: rotate(-90deg);\n    right: -10px;\n    width: 12px;\n    height: 12px;\n    display: block;\n}\n\n.react-calendar__navigation__next-button {\n    position: absolute;\n    top: 30%;\n    width: 16px;\n    height: 16px;\n    right: 13.5px;\n    min-width: 5px !important;\n    background-image: url('./chevron.svg') !important;\n    background-repeat: no-repeat !important;\n    background-size: contain !important;\n    padding: 0;\n    color: transparent !important;\n    transform: rotate(-90deg) translateY(-30%);;\n}\n\n.react-calendar__navigation__prev-button {\n    position: absolute;\n    background-image: url('./chevron.svg') !important;\n    background-repeat: no-repeat !important;\n    background-size: contain !important;\n    color: transparent !important;\n    padding: 0;\n    width: 16px;\n    height: 16px;\n    top: 30%;\n    right: 46px;\n    min-width: 5px !important;\n    transform: rotate(90deg) translateY(-30%);\n}\n\n\n.react-calendar__navigation__prev2-button {\n    display: none !important;\n}\n\n.react-calendar__navigation__next2-button {\n    display: none;\n}\n\n\n.react-calendar__month-view__days__day {\n    display: flex;\n    justify-content: center;\n    color: #909090 !important;\n    margin: 0  0 6px 0!important;\n    padding: 1.5px 0 !important;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n}\n\n.react-calendar__month-view__days__day--neighboringMonth {\n    color: #BFBFBF !important;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n    display: flex;\n    justify-content: center;\n    margin: 0  0 6px 0!important;\n    padding: 1.5px !important;\n}\n\n.react-calendar__month-view__weekdays {\n    margin-bottom: 8px !important;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    padding-right: 14px !important;\n    text-transform: lowercase !important;\n}\n\n.react-calendar__month-view__weekdays__weekday * {\n    text-decoration: none !important;\n}\n\n.react-calendar__navigation__label__labelText {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 13px;\n    line-height: 16px;\n    color: #909090 !important;\n}\n\n.react-date-picker__inputGroup__divider {\n    color: transparent;\n    display: none;\n}\n\n.date-input.not-empty .react-date-picker__inputGroup__divider {\n    position: relative;\n    left: -0.5px;\n    width: 4px;\n    display: block;\n}\n\n/* .react-date-picker__inputGroup {\n    max-width: 189px;\n} */\n\n\n.react-date-picker__inputGroup__divider::before {\n    content: '.';\n    position: absolute;\n    bottom: 1px;\n    left: 0;\n    display: block;\n    color: #151514;\n}\n\n.date-input.black-theme .react-date-picker__inputGroup__divider::before {\n    color: #F2F2F2 !important;\n}\n\n.react-date-picker__inputGroup__input {\n    border: none;\n    outline: none;\n}\n\n.react-date-picker__inputGroup {\n    padding-left: 16px !important;\n}\n\n.react-date-picker__inputGroup__input:invalid {\n    background-color: transparent !important;\n}\n\n.react-date-picker__calendar {\n    z-index: 3 !important;\n}\n\n.react-date-picker__calendar {\n    /* max-width: 221px !important;\n    max-height: 256px !important; */\n}\n\n.react-calendar__viewContainer {\n    padding: 4px 16px 24px 16px !important;\n}\n\n/* .react-calendar {\n    max-width: 221px !important;\n    max-height: 256px !important;\n} */\n\n\n.react-date-picker__inputGroup__leadingZero {\n    color: #151514 !important;\n}\n\n.react-date-picker__inputGroup__month::placeholder {\n    opacity: 0;\n}\n\n.react-date-picker__inputGroup__year::placeholder {\n    opacity: 0;\n}\n\n/* .react-calendar__tile {\n    display: flex;\n    justify-content: center;\n    color: #909090 !important;\n    margin: 0  0 12px 0!important;\n    padding: 3px !important;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n} */\n\n\n.react-calendar__year-view .react-calendar__tile {\n    display: flex;\n    justify-content: center;\n    color: #151514 !important;\n    margin: 0  0 12px 0!important;\n    padding: 0 !important;\n\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 13px;\n}\n\n.react-calendar button .react-calendar__tile--now {\n    color: white;\n}\n\n.react-calendar button:hover {\n    border-radius: 3px;\n}\n\n.react-calendar__tile--active {\n    background-color: #151514 !important;\n    border-radius: 3px;\n}\n\n.react-calendar__tile--active * {\n    color: white !important;\n}\n\n.react-calendar__tile--hasActive {\n    background-color: #151514 !important;\n    border-radius: 3px;\n    color: white;\n}\n\n.react-calendar__tile--hasActive * {\n    padding: 2px !important;\n    color: white;\n}\n\n.react-calendar__tile--now {\n    background-color: #909090 !important;\n    color: white !important;\n    border-radius: 3px;\n}\n\n/* .date-input::after {\n    content: '';\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    /* background:url(\"./date32.svg\") #f7f9fc no-repeat 97% 50%;\n    display: block;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 16px;\n}\n\n/* input[type=date]::-webkit-calendar-picker-indicator {\n    opacity: 0;\n    right: 10px;\n    top: 50%;\n    width: 32px;\n    height: 32px;\n    transform: translateY(-50%);\n    position: absolute;\n    z-index: 2;\n  }\n\n  input[type=date]::-webkit-clear-button {\n    color: #BFBFBF;\n  }\n  input[type=date]::-webkit-datetime-edit { padding: 1em; }\n  input[type=date]::-webkit-datetime-edit-fields-wrapper { background: silver; }\n  input[type=date]::-webkit-datetime-edit-text { color: red; padding: 0 0.3em; }\n  input[type=date]::-webkit-datetime-edit-month-field { color: blue; }\n  input[type=date]::-webkit-datetime-edit-day-field { color: green; }\n  input[type=date]::-webkit-datetime-edit-year-field { color: purple; }\n  input[type=date]::-webkit-inner-spin-button { display: none; }\n  input[type=date]::-webkit-datetime-edit {\n    -webkit-flex: 1;\n    -webkit-user-modify: read-only !important;\n    display: inline-block;\n    min-width: 0;\n    overflow: hidden;\n    color: tomato;\n} */\n\n  /* input[type=date]{\n\tbackground:url(\"./date32.svg\") #f7f9fc no-repeat 97% 50%;\n    } */\n\n/* @media(max-width: 940px) {\n    .date-input::after {\n        content: '';\n        position: absolute;\n        width: 32px;\n        height: 32px;\n        background:url(\"./date24.svg\") #f7f9fc no-repeat 97% 50%;\n        display: inline-block;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 16px;\n    }\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
